export default __webpack_public_path__ + "static/media/biot.c6be5078.png";